import getWidgetByName from "../requests";
import { Articles } from "../../articles/entities";
import {prop, take} from "ramda";

const getTopStoriesAsideWidget = () =>
  getWidgetByName("topstoriesasidewidget")
    .then(Articles)
    .then(prop("articles"))
    .then(take(5))

const getTopStoriesPanelWidget = () =>
  getWidgetByName("topstoriespanel")
    .then(Articles)
    .then(prop("articles"))

export { getTopStoriesAsideWidget, getTopStoriesPanelWidget };
